export default {
    HTTP: {
        id: 'HTTP',
        description: 'HTTPS Webhook'
    },
};



// WEBPACK FOOTER //
// ./src/modules/organization/models/NotificationChannelTypeId.ts